import startsWith from 'lodash/startsWith';
import React from 'react';
import getLocale from '../../helpers/getLocale';
import TermsEn from './TermsEn';
import TermsEs from './TermsEs';

function TermsOfService() {
  if (startsWith(getLocale(), 'es')) {
    return <TermsEs />;
  }

  return <TermsEn />;
}

export default TermsOfService;
